import { Formation } from "../types"

export const posfordupla: Formation = {
  id: "posfordupla",
  name: "0",
  category: "6 - 5",
  snapshots: [
    {
      players: [
        {
          x: 5.073837353194771,
          y: 6.327155529099696
        },
        {
          x: 8.17859978715721,
          y: 6.295962207206261
        },
        {
          x: 8.569801995973576,
          y: 2.9859720683582083
        },
        {
          x: 5.941598434174788,
          y: 1.6936057579560093
        },
        {
          x: 12.839977815871883,
          y: 1.6493513501530765
        },
        {
          x: 1.36168700734347,
          y: 1.5758176596218825
        }
      ],
      opponents: [
        {
          x: 7.091099200140476,
          y: 2.3413806400276287
        },
        {
          x: 8.519144730471083,
          y: 3.6875098808407074
        },
        {
          x: 10.882409445558682,
          y: 1.92971841864546
        },
        {
          x: 5.776778773737353,
          y: 3.765908627527162
        },
        {
          x: 4.1731703563403055,
          y: 2.6631620491419783
        }
      ],
      ball: {
        x: 12.483653206409377,
        y: 2.43967442301724
      },
      goalkeepers: [
        {
          x: 7.079437073556041,
          y: 1.087305340145936
        }
      ]
    }
  ]
}
